import { AxiosResponse } from 'axios'
import { stringify } from 'qs'
import { HttpClient } from '@opallabs/api'
import { AssignmentsFetchParams } from './types'

type AssignmentsFetcher = (
  arg: AssignmentsFetchParams
) => Promise<AxiosResponse>

export const fetchAssignments: AssignmentsFetcher = (params) =>
  HttpClient().get(
    `/workflows/v2/assignments?${stringify(
      { ...params },
      { arrayFormat: 'brackets' }
    )}`
  )
